import { $api, type InferResponse } from '@/api/typedClient'
import { useTenantStore } from '@/stores/tenantStore'
import type { components } from '@/types/api/v1'

export type InvoiceDisplayRow = components['schemas']['InvoiceDisplayRow']
export type InvoiceOutput = components['schemas']['Invoice-Output']

export type InvoicesForOrderResponse = InferResponse<
  '/crossroads/invoice/by_order/{order_id}',
  'get'
>

export function useInvoicesForOrder(orderId: string | null | undefined) {
  const { selectedTenant } = useTenantStore()
  const shouldFetch = !!orderId && !!selectedTenant?.name

  return $api.useQuery(
    'get',
    '/crossroads/invoice/by_order/{order_id}',
    { params: { path: { order_id: orderId ?? '' } } },
    { enabled: shouldFetch },
  )
}
